module.exports = ".tab-content.tabcontent-border #home.tab-pane .form {\n  margin-top: 35px;\n  padding: 0 15px !important; }\n\n.tab-content.tabcontent-border #home .form .form-body {\n  border: 1px solid #D0DBE6;\n  padding: 0px 5px !important;\n  border-radius: 3px !important; }\n\n.ui-dropdown .ui-dropdown-label {\n  padding-right: 10px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-log/app-log.component.scss
// module id = ./src/app/components/app-log/app-log.component.scss
// module chunks = main